"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutFooter = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CheckoutFooter = exports.CheckoutFooter = function CheckoutFooter(_ref) {
  var belowMd = _ref.belowMd;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-10 font-extralight leading-none text-white mx-auto ".concat(belowMd ? "mt-20" : "mt-32 max-w-3xl", " text-sm")
  });
};